Object.defineProperty(exports, "__esModule", { value: true });
exports.containerReset = exports.fluidReset = exports.wrapperReset = exports.flexReset = exports.boxReset = void 0;
exports.boxReset = {
    ncss: {
        boxSizing: 'border-box',
    },
};
exports.flexReset = {
    ncss: Object.assign(Object.assign({}, exports.boxReset.ncss), { display: 'flex' }),
};
exports.wrapperReset = {
    ncss: Object.assign(Object.assign({}, exports.boxReset.ncss), { w: 1 }),
};
exports.fluidReset = {
    ncss: Object.assign(Object.assign({}, exports.flexReset.ncss), { w: 1 }),
};
exports.containerReset = {
    ncss: Object.assign(Object.assign({}, exports.fluidReset.ncss), { maxWidth: '1280px', mx: 'auto' }),
};
//# sourceMappingURL=grid-reset.js.map